import React from "react";

export function ContentWrapper({ children, style = {}}) {
  return (
    <div style={{padding: "15px", ...style}}>
      {children}
    </div>
  );
}
